(() => {
  const setupImageLightbox = (root) => {
    if (root.dataset.ut2LightboxReady === "true") return;
    const triggers = Array.from(root.querySelectorAll("[data-ut2-lightbox-trigger]"));
    if (!triggers.length) return;

    root.dataset.ut2LightboxReady = "true";
    const dialog = document.createElement("dialog");
    dialog.className = "ut2-image-lightbox";
    dialog.setAttribute("aria-label", "Product image preview");
    dialog.innerHTML = `
      <button class="ut2-image-lightbox__close" type="button" aria-label="Close image preview">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18"></path>
        </svg>
      </button>
      <div class="ut2-image-lightbox__stage">
        <img class="ut2-image-lightbox__image" alt="">
      </div>
    `;
    root.appendChild(dialog);

    const preview = dialog.querySelector(".ut2-image-lightbox__image");
    const closeButton = dialog.querySelector(".ut2-image-lightbox__close");
    let activeTrigger = null;

    const close = () => {
      if (dialog.open) dialog.close();
    };

    const open = (trigger) => {
      activeTrigger = trigger;
      preview.src = trigger.dataset.ut2LightboxSrc || trigger.currentSrc || trigger.src;
      preview.alt = trigger.alt || "Product image";
      dialog.showModal();
    };

    triggers.forEach((trigger) => {
      trigger.setAttribute("role", "button");
      trigger.setAttribute("tabindex", "0");
      trigger.setAttribute("aria-label", `${trigger.alt || "Product image"} - enlarge`);
      trigger.addEventListener("click", () => open(trigger));
      trigger.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        open(trigger);
      });
    });

    closeButton.addEventListener("click", close);
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog || event.target.classList.contains("ut2-image-lightbox__stage")) {
        close();
      }
    });
    dialog.addEventListener("close", () => {
      preview.removeAttribute("src");
      activeTrigger?.focus({ preventScroll: true });
      activeTrigger = null;
    });
  };

  document.querySelectorAll("[data-ut2-static]").forEach(setupImageLightbox);
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-ut2-static]").forEach(setupImageLightbox);
  });
})();

(() => {
  const hydrateCopy = (root) => {
    const data = root.querySelector("[data-ut2-messages]");
    if (!data) return;
    let messages;
    try {
      messages = JSON.parse(data.textContent);
    } catch {
      return;
    }
    window.UT2_LOCALES = window.UT2_LOCALES || {};
    window.UT2_LOCALES.en = messages;
    document.documentElement.dataset.resolvedLocale = "en";
    document.title = "UT2 Clearance Deal | UnifyDrive";
    const heroDealMessage = root.querySelector(
      '[data-pencil-name="Hero Offer Eyebrow"] [data-pencil-name="Label"]'
    );
    if (heroDealMessage) heroDealMessage.dataset.i18n = "hero.dealMessage";
    root.querySelectorAll("[data-i18n]").forEach((element) => {
      const key = element.dataset.i18n;
      if (Object.prototype.hasOwnProperty.call(messages, key)) {
        element.textContent = messages[key];
      }
    });

    const currency = root.dataset.currency || "USD";
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || "en-US", {
      style: "currency",
      currency,
      maximumFractionDigits: 0
    }).format(Number(cents || 0) / 100);
    const standardPrice = Number(root.dataset.standardPrice || 0);
    const bundlePrice = Number(root.dataset.bundlePrice || 0);
    const standardCompare = Number(root.dataset.standardComparePrice || standardPrice);
    const bundleCompare = Number(root.dataset.bundleComparePrice || bundlePrice);
    const maxSaving = Math.max(standardCompare - standardPrice, bundleCompare - bundlePrice) + 9000;
    const hero = root.querySelector('[data-pencil-name="S3 Hero"]');
    const price = hero?.querySelector('[data-pencil-name="Price"]');
    const desc = hero?.querySelector('[data-pencil-name="Desc"]');
    const saveLabel = hero?.querySelector('[data-pencil-name="Save Pill"] [data-pencil-name="Label"]');
    const saveAmount = hero?.querySelector('[data-pencil-name="Save Pill"] [data-pencil-name="Amount"]');
    const offerPrice = hero?.querySelector('[data-pencil-name="Offer Price"]');
    const offerMeta = hero?.querySelector('[data-pencil-name="Offer Meta"]');
    const offerSaveLabel = hero?.querySelector('[data-pencil-name="Offer Save Label"]');
    const offerSaveAmount = hero?.querySelector('[data-pencil-name="Offer Save Amount"]');
    const mobileSummary = hero?.querySelector('[data-pencil-name="Offer Mobile Summary"]');
    const promoMessage = root.querySelector('[data-pencil-name="S1 Promo Banner"] [data-pencil-name="Msg 2"]');
    if (price) price.textContent = `Starting at ${money(standardPrice)}`;
    if (desc) desc.textContent = "Standard UT2";
    if (saveLabel) saveLabel.textContent = messages["copy.016"] || "Extra savings";
    if (saveAmount) saveAmount.textContent = currency === "USD" ? `Up to ${money(maxSaving)} each` : "Up to $90 extra each";
    if (offerPrice) offerPrice.textContent = money(standardPrice);
    if (offerMeta) offerMeta.textContent = "Standard UT2";
    if (offerSaveLabel) offerSaveLabel.textContent = messages["copy.016"] || "Extra savings";
    if (offerSaveAmount) offerSaveAmount.textContent = currency === "USD" ? `Up to ${money(maxSaving)} each` : "Up to $90 extra each";
    if (mobileSummary) mobileSummary.textContent = "Buy 2–3, save $20 each · Buy 4+, save $90 each";
    if (promoMessage) promoMessage.textContent = messages["copy.002"] || "BUY 4+ UT2s · SAVE $90 EACH";
  };

  document.querySelectorAll("[data-ut2-static]").forEach(hydrateCopy);
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-ut2-static]").forEach(hydrateCopy);
  });
})();

(() => {
  const valueNode = document.querySelector(
    '[data-pencil-name="Stat Speed"] [data-pencil-name="Value"]'
  );

  const minSpeed = 290;
  const maxSpeed = 312;
  const animationDuration = 1800;
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  const listeners = new Set();
  let currentSpeed = null;

  const meter = {
    subscribe(listener) {
      if (typeof listener !== 'function') return () => {};
      listeners.add(listener);
      if (currentSpeed !== null) listener(currentSpeed);
      return () => listeners.delete(listener);
    }
  };

  window.ut2SpeedMeter = meter;

  const setSpeed = (speed) => {
    currentSpeed = Number(speed);
    if (valueNode) valueNode.textContent = currentSpeed.toFixed(1);
    listeners.forEach((listener) => listener(currentSpeed));
  };

  if (reducedMotion?.matches) {
    setSpeed(maxSpeed);
    return;
  }

  const startedAt = performance.now();
  const animate = (now) => {
    if (reducedMotion?.matches) {
      setSpeed(maxSpeed);
      return;
    }

    const progress = Math.min(1, (now - startedAt) / animationDuration);
    const easedProgress = 1 - Math.pow(1 - progress, 3);
    setSpeed(minSpeed + (maxSpeed - minSpeed) * easedProgress);

    if (progress < 1) window.requestAnimationFrame(animate);
  };

  window.requestAnimationFrame(animate);
})();

(() => {
  const query = (selector, scope = document) => scope.querySelector(selector);
  const queryAll = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const messages = () => {
    const registry = window.UT2_LOCALES || {};
    return registry[document.documentElement.dataset.resolvedLocale] || registry.en || {};
  };
  const text = (key, fallback = "") => messages()[key] || fallback;
  const formatMoney = (value, currency = "USD") => new Intl.NumberFormat(
    document.documentElement.lang || "en-US",
    { style: "currency", currency, maximumFractionDigits: 0 }
  ).format(value);

  const bindKeyboardActivation = (element, handler) => {
    if (!element) return;
    element.setAttribute("role", "button");
    element.tabIndex = 0;
    element.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      handler(event);
    });
  };

  const setupOrderBuilder = () => {
    const section = query('[data-pencil-name="S4 Order Builder"]');
    if (!section) return;
    const shopifyRoot = section.closest("[data-ut2-static]");

    const standard = query('[data-pencil-name="Standard UT2"]', section);
    const bundle = query('[data-pencil-name="UT2 Bundle"]', section);
    const totalPanel = query('[data-pencil-name="Total Panel"]', section);
    if (!standard || !bundle || !totalPanel) return;

    const maxDevices = 99;
    const state = window.UT2PricingRules.defaultOrderQuantities();
    const currency = shopifyRoot?.dataset.currency || "USD";
    const standardUnitPrice = Number(shopifyRoot?.dataset.standardPrice || 0) / 100;
    const bundleUnitPrice = Number(shopifyRoot?.dataset.bundlePrice || 0) / 100;
    const standardPriceNode = query('[data-pencil-name="Price"]', query('[data-pencil-name="Title Row"]', standard));
    const bundlePriceNode = query('[data-pencil-name="Price"]', query('[data-pencil-name="Title Row"]', bundle));
    if (standardPriceNode) standardPriceNode.textContent = `Current price ${formatMoney(standardUnitPrice, currency)}`;
    if (bundlePriceNode) bundlePriceNode.textContent = `Current price ${formatMoney(bundleUnitPrice, currency)}`;
    const controls = [
      { type: "standard", root: standard },
      { type: "bundle", root: bundle }
    ];
    let priceAnimationTimer;

    const update = (animatePrice = false) => {
      const totalQty = state.standard + state.bundle;
      const standardPriceCents = Number(shopifyRoot?.dataset.standardPrice || 0);
      const bundlePriceCents = Number(shopifyRoot?.dataset.bundlePrice || 0);
      const standardComparePriceCents = Number(shopifyRoot?.dataset.standardComparePrice || standardPriceCents);
      const bundleComparePriceCents = Number(shopifyRoot?.dataset.bundleComparePrice || bundlePriceCents);
      const pricing = window.UT2PricingRules.calculateOrder({
        standardQty: state.standard,
        bundleQty: state.bundle,
        standardPriceCents,
        bundlePriceCents,
        standardComparePriceCents,
        bundleComparePriceCents
      });
      const isUsd = currency === "USD";
      const total = (isUsd ? pricing.totalCents : pricing.subtotalCents) / 100;
      const saving = pricing.savingsCents / 100;
      const baseSavingCents = state.standard * Math.max(0, standardComparePriceCents - standardPriceCents)
        + state.bundle * Math.max(0, bundleComparePriceCents - bundlePriceCents);
      const extraSavingCents = totalQty * pricing.discountEachCents;
      const parts = [];

      if (state.standard) parts.push(`${state.standard} ${text("order.standard", "Standard")}`);
      if (state.bundle) parts.push(`${state.bundle} ${text("order.bundle", "Bundle")}`);

      controls.forEach(({ type, root }) => {
        const quantity = state[type];
        const productPriceCents = type === "standard" ? standardPriceCents : bundlePriceCents;
        const productCompareCents = type === "standard" ? standardComparePriceCents : bundleComparePriceCents;
        const productBaseSavingCents = quantity * Math.max(0, productCompareCents - productPriceCents);
        const productExtraSavingCents = quantity * pricing.discountEachCents;
        const productSaving = (productBaseSavingCents + productExtraSavingCents) / 100;
        const count = query('[data-pencil-name="Count"]', root);
        const minus = query('[data-pencil-name="Minus"]', root);
        const plus = query('[data-pencil-name="Plus"]', root);
        const productSaveBadge = query('[data-pencil-name="Product Save Badge"]', root);
        const productSavePrefix = query('[data-pencil-name="Product Save Prefix"]', productSaveBadge);
        const productSaveAmount = query('[data-pencil-name="Product Save Amount"]', productSaveBadge);
        const badgeCopy = window.UT2PricingRules.savingsBadgeCopy(productSaving * 100);
        if (count) {
          const otherType = type === "standard" ? "bundle" : "standard";
          count.max = String(maxDevices - state[otherType]);
          if (document.activeElement !== count || count.value !== "") count.value = String(quantity);
        }
        if (minus) {
          minus.setAttribute("aria-disabled", String(quantity === 0));
          minus.dataset.orderControl = "true";
        }
        if (plus) {
          plus.setAttribute("aria-disabled", String(totalQty >= maxDevices));
          plus.dataset.orderControl = "true";
        }
        if (productSavePrefix) productSavePrefix.textContent = badgeCopy.label;
        if (productSaveAmount) {
          productSaveAmount.textContent = productSaving
            ? (isUsd ? badgeCopy.amount : formatMoney(productBaseSavingCents / 100, currency))
            : "";
        }
        if (productSaveBadge) productSaveBadge.setAttribute("aria-hidden", String(!productSaving));
      });

      const totalValue = query('[data-pencil-name="Total"]', totalPanel);
      const totalLabel = query('[data-pencil-name="Price Summary"] [data-pencil-name="Label"]', totalPanel);
      const combo = query('[data-pencil-name="Combo"]', totalPanel);
      const savingsSummary = query('[data-pencil-name="Savings"]', totalPanel);
      const savingsLabel = query('[data-pencil-name="Savings Label"]', savingsSummary);
      const savingsAmount = query('[data-pencil-name="Savings Amount"]', savingsSummary);
      const buildOrder = query('[data-pencil-name="Build Order"]', totalPanel);
      if (totalValue) totalValue.textContent = formatMoney(total, currency);
      if (totalLabel) totalLabel.textContent = isUsd ? "ORDER TOTAL" : "SUBTOTAL BEFORE SAVINGS";
      if (combo) combo.textContent = parts.length ? parts.join(" + ") : text("order.empty", "Add devices to begin");
      if (savingsLabel) savingsLabel.textContent = "TOTAL SAVINGS";
      if (savingsAmount) {
        savingsAmount.textContent = saving
          ? (isUsd
            ? formatMoney(saving, "USD")
            : `${formatMoney(baseSavingCents / 100, currency)} + ${formatMoney(extraSavingCents / 100, "USD")} extra`)
          : "";
      }
      if (savingsSummary) savingsSummary.setAttribute("aria-hidden", String(!saving));
      if (buildOrder) {
        buildOrder.setAttribute("aria-disabled", String(totalQty === 0));
        buildOrder.dataset.orderControl = "true";
      }
      totalPanel.classList.toggle("has-savings", saving > 0);
      if (animatePrice) {
        totalPanel.classList.remove("price-updated");
        void totalPanel.offsetWidth;
        totalPanel.classList.add("price-updated");
        window.clearTimeout(priceAnimationTimer);
        priceAnimationTimer = window.setTimeout(() => totalPanel.classList.remove("price-updated"), 650);
      }
    };

    const setQuantity = (type, value) => {
      const parsed = Number.parseInt(value, 10);
      const nextQuantity = Number.isFinite(parsed) ? parsed : 0;
      const otherType = type === "standard" ? "bundle" : "standard";
      const maxForType = maxDevices - state[otherType];
      const changed = state[type] !== Math.min(maxForType, Math.max(0, nextQuantity));
      state[type] = Math.min(maxForType, Math.max(0, nextQuantity));
      update(changed);
    };

    controls.forEach(({ type, root }) => {
      const minus = query('[data-pencil-name="Minus"]', root);
      const plus = query('[data-pencil-name="Plus"]', root);
      const count = query('[data-pencil-name="Count"]', root);
      if (count) {
        count.type = "text";
        count.inputMode = "numeric";
        count.pattern = "[0-9]*";
        count.autocomplete = "off";
        count.addEventListener("input", () => setQuantity(type, count.value));
        count.addEventListener("blur", () => {
          if (count.value === "") count.value = String(state[type]);
        });
      }
      [minus, plus].forEach((control) => {
        if (!control) return;
        control.dataset.orderControl = "true";
        const actionKey = control === plus ? "order.add" : "order.remove";
        const productKey = type === "standard" ? "order.standard" : "order.bundle";
        control.setAttribute("aria-label", `${text(actionKey)} ${text(productKey)}`);
        bindKeyboardActivation(control, () => {
          if (control.getAttribute("aria-disabled") === "true") return;
          const delta = control === plus ? 1 : -1;
          if (delta > 0 && state.standard + state.bundle >= maxDevices) return;
          setQuantity(type, state[type] + delta);
        });
        control.addEventListener("click", () => {
          if (control.getAttribute("aria-disabled") === "true") return;
          const delta = control === plus ? 1 : -1;
          if (delta > 0 && state.standard + state.bundle >= maxDevices) return;
          setQuantity(type, state[type] + delta);
        });
      });
    });

    update();
  };

  const setupPricingCards = () => {
    const cards = queryAll('[data-pencil-name="S8 Pricing"] > [data-pencil-name="Cards"] > [data-pencil-name]');
    if (!cards.length) return;
    const root = query("[data-ut2-static]");
    const currency = root?.dataset.currency || "USD";
    const standardPrice = Number(root?.dataset.standardPrice || 0) / 100;
    const bundlePrice = Number(root?.dataset.bundlePrice || 0) / 100;
    const standardCompare = Number(root?.dataset.standardComparePrice || 0) / 100;
    const bundleCompare = Number(root?.dataset.bundleComparePrice || 0) / 100;
    const tiers = [
      { quantity: 1, label: "1 UT2", devices: "Current price", discount: 0, tag: "Current clearance price" },
      { quantity: 2, label: "2–3 UT2s", devices: "Save $20 each", discount: 20, tag: "Extra $20 off each" },
      { quantity: 4, label: "4+ UT2s", devices: "Save $90 each", discount: 90, tag: "Extra $90 off each" }
    ];

    const pricingActions = [
      "pricing.cta.individual",
      "pricing.cta.smallTeam",
      "pricing.cta.bestValue"
    ];
    const pricingQuantities = [1, 2, 4];

    cards.forEach((card, index) => {
      const labelKey = pricingActions[index] || pricingActions[0];
      let wrap = query('.pricing-cta-wrap', card);
      if (!wrap) {
        wrap = query('[data-pencil-name="CTA Wrap"]', card);
        if (wrap) wrap.classList.add("pricing-cta-wrap");
      }
      if (!wrap) {
        wrap = document.createElement("div");
        wrap.dataset.pencilName = "CTA Wrap";
        wrap.className = "pricing-cta-wrap";
        wrap.style.cssText = "align-items:flex-start;display:flex;flex-direction:column;width:100%";
        card.append(wrap);
      }

      let action = query('.pricing-hover-cta', wrap);
      if (!action) action = query('[data-pencil-name="CTA"]', wrap);
      if (!action) {
        action = document.createElement("div");
        action.dataset.pencilName = "CTA";
        action.style.cssText = "align-items:center;background-color:#3181FF;border-radius:12px;display:flex;gap:8px;justify-content:center;padding:14px 24px;width:100%";
        wrap.append(action);
      }
      action.classList.add("ut2-action-button", "pricing-hover-cta");
      let label = query('[data-pencil-name="Label"]', action);
      if (!label) {
        label = document.createElement("div");
        label.dataset.pencilName = "Label";
        action.append(label);
      }
      label.dataset.i18n = labelKey;
      label.textContent = text(labelKey, "Build Order");
      action.setAttribute("aria-label", label.textContent);
      action.setAttribute("role", "button");
      action.tabIndex = 0;
      action.dataset.pricingQuantity = String(pricingQuantities[index] || 1);
      action.dataset.pricingVariant = "standard";
    });

    cards.forEach((card, index) => {
      const data = tiers[index] || tiers[0];
      card.hidden = false;
      card.style.removeProperty("display");
      const cardLabel = query('[data-pencil-name="Top"] [data-pencil-name="Label"]', card);
      const devices = query('[data-pencil-name="Devices"]', card);
      if (cardLabel) cardLabel.textContent = data.label;
      if (devices) devices.textContent = data.devices;
      const standardRow = query('[data-pencil-name="Standard UT2"]', card);
      const bundleRow = query('[data-pencil-name="UT2 Bundle"]', card);
      [
        { row: standardRow, name: "Standard UT2", price: standardPrice, compare: standardCompare },
        { row: bundleRow, name: "UT2 Bundle", price: bundlePrice, compare: bundleCompare }
      ].forEach(({ row, name, price, compare }) => {
        if (!row) return;
        row.hidden = false;
        row.style.display = "flex";
        const rowPrice = query('[data-pencil-name="Price"]', row);
        const was = query('[data-pencil-name="Was"]', row);
        const discountedPrice = currency === "USD" ? Math.max(0, price - data.discount) : price;
        if (rowPrice) rowPrice.textContent = formatMoney(discountedPrice, currency);
        if (was) {
          was.textContent = compare > price ? `Was ${formatMoney(compare, currency)}` : "";
          was.hidden = !(compare > price);
        }
        const rowName = query('[data-pencil-name="Name"]', row);
        if (rowName) rowName.textContent = name;
      });
      const tag = query('[data-pencil-name="Tag"] [data-pencil-name="Text"]', card);
      if (tag) tag.textContent = data.tag;
    });

    const setSelected = (selected) => {
      cards.forEach((card) => {
        const active = card === selected;
        card.classList.toggle("is-selected", active);
        card.setAttribute("aria-pressed", String(active));
      });
    };

    cards.forEach((card) => {
      card.classList.add("interactive-pricing-card");
      bindKeyboardActivation(card, () => setSelected(card));
      card.addEventListener("click", () => setSelected(card));
      card.addEventListener("mouseenter", () => card.classList.add("is-hovered"));
      card.addEventListener("mouseleave", () => card.classList.remove("is-hovered"));
      card.addEventListener("focusin", () => card.classList.add("is-hovered"));
      card.addEventListener("focusout", (event) => {
        if (!card.contains(event.relatedTarget)) card.classList.remove("is-hovered");
      });
    });

    cards.forEach((card) => {
      card.classList.remove("is-selected");
      card.setAttribute("aria-pressed", "false");
    });
  };

  const specRows = {
    "Storage and Connectivity": [
      ["copy.162", "copy.163"],
      ["copy.164", "copy.165"],
      ["copy.166", "copy.167"],
      ["copy.168", "copy.169"],
      ["copy.170", "copy.171"],
      ["copy.172", "copy.173"]
    ],
    "Physical and Power": [
      ["copy.174", "copy.175"],
      ["copy.176", "copy.177"],
      ["copy.178", "copy.179"],
      ["copy.180", "copy.181"]
    ]
  };

  const createSpecRows = (group, entries) => {
    const rows = document.createElement("div");
    rows.dataset.pencilName = "Rows";
    rows.className = "interactive-spec-rows";
    entries.forEach(([labelKey, valueKey]) => {
      const row = document.createElement("div");
      row.dataset.pencilName = "Spec Row";
      row.className = "interactive-spec-row";
      const label = document.createElement("span");
      label.dataset.pencilName = "Label";
      label.dataset.i18n = labelKey;
      label.textContent = text(labelKey);
      const value = document.createElement("strong");
      value.dataset.pencilName = "Value";
      value.dataset.i18n = valueKey;
      value.textContent = text(valueKey);
      row.append(label, value);
      rows.append(row);
    });
    group.append(rows);
    return rows;
  };

  const setupSpecs = () => {
    const section = query('[data-pencil-name="S9 Specs"]');
    if (!section) return;

    const tileIcons = {
      "16TB": "hard-drive",
      "2.5GbE": "wifi",
      "8GB": "layers",
      "306g": "truck"
    };
    Object.entries(tileIcons).forEach(([tileName, iconName]) => {
      const tile = query(`[data-pencil-name="${tileName}"]`, section);
      if (!tile || query('.spec-tile-icon-wrap', tile)) return;
      const source = query(`svg[data-icon-name="${iconName}"]`);
      if (!source) return;

      const wrap = document.createElement("div");
      wrap.className = "spec-tile-icon-wrap";
      wrap.setAttribute("aria-hidden", "true");
      const icon = source.cloneNode(true);
      icon.classList.add("spec-tile-icon");
      icon.removeAttribute("style");
      icon.setAttribute("focusable", "false");
      wrap.append(icon);
      tile.append(wrap);
    });

    const groupsRoot = query('[data-pencil-name="Groups"]', section);
    if (!groupsRoot) return;
    const groups = Array.from(groupsRoot.children);
    const downPath = groups.slice(1)
      .map((group) => query('[data-pencil-name="Chevron"] path', group))
      .find(Boolean);

    const setOpen = (group, open) => {
      const rows = query('[data-pencil-name="Rows"]', group);
      if (!rows) return;
      group.classList.toggle("is-open", open);
      rows.setAttribute("aria-hidden", String(!open));
      rows.style.maxHeight = open ? `${rows.scrollHeight}px` : "0px";
    };

    groups.forEach((group, index) => {
      const name = group.dataset.pencilName;
      const header = query('[data-pencil-name="Header"]', group);
      let rows = query('[data-pencil-name="Rows"]', group);
      if (!rows && specRows[name]) rows = createSpecRows(group, specRows[name]);
      if (!header || !rows) return;

      group.classList.add("interactive-spec-group");
      rows.classList.add("interactive-spec-rows");
      if (downPath) {
        const chevron = query('[data-pencil-name="Chevron"]', header);
        if (chevron) chevron.replaceChildren(downPath.cloneNode(true));
      }

      header.setAttribute("aria-expanded", String(index === 0));
      const toggle = () => {
        const nextOpen = !group.classList.contains("is-open");
        groups.forEach((candidate) => {
          const candidateHeader = query('[data-pencil-name="Header"]', candidate);
          if (candidateHeader) candidateHeader.setAttribute("aria-expanded", String(candidate === group && nextOpen));
          setOpen(candidate, candidate === group && nextOpen);
        });
      };
      bindKeyboardActivation(header, toggle);
      header.addEventListener("click", toggle);
      setOpen(group, index === 0);
    });

    window.addEventListener("resize", () => {
      groups.forEach((group) => {
        if (!group.classList.contains("is-open")) return;
        const rows = query('[data-pencil-name="Rows"]', group);
        if (rows) rows.style.maxHeight = `${rows.scrollHeight}px`;
      });
    }, { passive: true });
  };

  const faqAnswers = ["copy.151", "copy.182", "copy.183", "copy.184", "copy.185"];

  const setupFaq = () => {
    const list = query('[data-pencil-name="S11 FAQ"] [data-pencil-name="List"]');
    if (!list) return;
    const items = Array.from(list.children);
    const setOpen = (item, open) => {
      const answer = query('.interactive-faq-answer', item);
      if (!answer) return;
      item.classList.toggle("is-open", open);
      answer.setAttribute("aria-hidden", String(!open));
      answer.style.maxHeight = open ? `${answer.scrollHeight}px` : "0px";
    };

    const downPath = items.slice(1)
      .map((item) => query('[data-pencil-name="Chevron"] path', item))
      .find(Boolean);

    items.forEach((item, index) => {
      const header = query('[data-pencil-name="Header"]', item);
      if (!header) return;
      item.classList.add("interactive-faq-item");
      let answer = query('[data-pencil-name="Answer"]', item);
      if (!answer) {
        answer = document.createElement("div");
        answer.dataset.pencilName = "Answer";
        answer.dataset.i18n = faqAnswers[index];
        answer.textContent = text(faqAnswers[index]);
        item.append(answer);
      }
      answer.classList.add("interactive-faq-answer");
      if (downPath) {
        const chevron = query('[data-pencil-name="Chevron"]', header);
        if (chevron) chevron.replaceChildren(downPath.cloneNode(true));
      }

      header.setAttribute("aria-expanded", String(index === 0));
      const toggle = () => {
        const nextOpen = !item.classList.contains("is-open");
        items.forEach((candidate) => {
          const candidateHeader = query('[data-pencil-name="Header"]', candidate);
          if (candidateHeader) candidateHeader.setAttribute("aria-expanded", String(candidate === item && nextOpen));
          setOpen(candidate, candidate === item && nextOpen);
        });
      };
      bindKeyboardActivation(header, toggle);
      header.addEventListener("click", toggle);
      setOpen(item, index === 0);
    });

    window.addEventListener("resize", () => {
      items.forEach((item) => {
        if (!item.classList.contains("is-open")) return;
        const answer = query('.interactive-faq-answer', item);
        if (answer) answer.style.maxHeight = `${answer.scrollHeight}px`;
      });
    }, { passive: true });
  };

  const setupVideo = () => {
    const video = query('[data-pencil-name="S6 Workflow"] .workflow-video');
    if (!video) return;
    video.muted = true;
    const play = () => video.play().catch(() => {});
    if (video.readyState >= 2) play();
    else video.addEventListener("loadeddata", play, { once: true });
  };

  const setupWorkflowTransfer = () => {
    const network = query('[data-pencil-name="S6 Workflow"] [data-pencil-name="Network Cell"]');
    if (!network) return;

    const speedNode = query('[data-pencil-name="Data Row"] [data-pencil-name="Value"]', network);
    const nodeNames = ["CAMERA", "UT2", "STUDIO"];
    const nodes = nodeNames
      .map((name) => query(`[data-pencil-name="${name}"]`, network))
      .filter(Boolean);
    const arrows = queryAll('[data-pencil-name^="Arrow"]', network);
    if (nodes.length !== 3 || arrows.length !== 2) return;

    nodes.forEach((node) => node.classList.add("workflow-transfer-node"));
    arrows.forEach((arrow) => arrow.classList.add("workflow-transfer-arrow"));

    const setActive = (phase) => {
      const activeNode = phase === 0 ? 0 : phase === 2 ? 1 : phase === 4 ? 2 : -1;
      const activeArrow = phase === 1 ? 0 : phase === 3 ? 1 : -1;
      nodes.forEach((node, nodeIndex) => node.classList.toggle("is-active", nodeIndex === activeNode));
      arrows.forEach((arrow, arrowIndex) => arrow.classList.toggle("is-active", arrowIndex === activeArrow));
    };

    const speedTemplate = text("copy.058", "312.5 MB/s*");
    const speedMatch = speedTemplate.match(/^[-+]?\d[\d.,]*/);
    const suffix = speedTemplate.slice(speedMatch?.[0].length || 0).trimStart();
    let speedNumberNode = null;

    if (speedNode) {
      speedNumberNode = document.createElement("span");
      speedNumberNode.className = "transfer-speed-number";
      const speedUnitNode = document.createElement("span");
      speedUnitNode.className = "transfer-speed-unit";
      speedUnitNode.textContent = suffix;
      speedNode.textContent = "";
      speedNode.classList.add("transfer-speed-value");
      speedNode.append(speedNumberNode, speedUnitNode);
    }

    const setSpeed = (integerPart, decimalDigit) => {
      if (speedNumberNode) speedNumberNode.textContent = `${integerPart}.${decimalDigit}`;
    };

    setActive(0);
    if (speedNode) speedNode.dataset.transferSpeed = "true";

    const applySharedSpeed = (speed) => {
      const [integerPart, decimalDigit] = Number(speed).toFixed(1).split(".");
      setSpeed(integerPart, decimalDigit);
    };

    if (window.ut2SpeedMeter?.subscribe) {
      window.ut2SpeedMeter.subscribe(applySharedSpeed);
    } else {
      applySharedSpeed(312);
    }

    let transferPhase = 0;
    const advanceTransfer = () => {
      setActive(transferPhase);
      transferPhase = (transferPhase + 1) % 5;
    };

    advanceTransfer();
    window.setInterval(advanceTransfer, 900);
  };

  const setupTeamSharing = () => {
    const map = query('[data-pencil-name="S7 Team Sharing"] [data-pencil-name="Share Map"]');
    if (!map) return;
    map.classList.add("team-sharing-map");

    const stepSelectors = [
      '[data-pencil-name="Upload Node"]',
      '[data-pencil-name="Line 1"]',
      '[data-pencil-name="Hub"]',
      '[data-pencil-name="Line 2"]',
      '[data-pencil-name="Group Files"]',
      '[data-pencil-name="Line 3"]',
      '[data-pencil-name="Bus"]'
    ];
    const steps = stepSelectors.map((selector) => query(selector, map)).filter(Boolean);
    const drops = queryAll('[data-pencil-name="Drop"]', map);
    const crew = ["Camera crew", "Editor", "Producer", "Client review"]
      .map((name) => query(`[data-pencil-name="${name}"]`, map))
      .filter(Boolean);
    const sequence = [...steps, ...drops, ...crew];
    if (sequence.length < 7) return;

    steps.forEach((element) => {
      const isLine = element.dataset.pencilName === "Bus" || element.dataset.pencilName.startsWith("Line ");
      element.classList.add(isLine ? "team-share-line" : "team-share-step");
    });
    drops.forEach((drop) => drop.classList.add("team-share-drop"));
    crew.forEach((member) => member.classList.add("team-share-step"));

    const setPhase = (phase) => {
      sequence.forEach((element, index) => {
        element.classList.toggle("is-revealed", phase >= 0 && index <= phase);
        element.classList.toggle("is-active", index === phase);
      });
    };

    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    if (reducedMotion?.matches) {
      map.classList.add("team-sharing-static");
      sequence.forEach((element) => element.classList.remove("is-active"));
      return;
    }

    const introDuration = 1700;
    const stepDuration = 520;
    const holdDuration = 7000;
    const exitDuration = 500;
    const pauseDuration = 500;
    const startedAt = performance.now();
    const transferDuration = sequence.length * stepDuration;
    const transferEnd = introDuration + transferDuration;
    const exitStart = transferEnd + holdDuration;
    const exitEnd = exitStart + exitDuration;
    const cycleDuration = exitEnd + pauseDuration;
    const animate = (now) => {
      if (reducedMotion?.matches) {
        map.classList.add("team-sharing-static");
        map.classList.remove("is-cycle-visible", "is-cycle-exiting");
        sequence.forEach((element) => element.classList.remove("is-active"));
        return;
      }

      const cycleTime = (now - startedAt) % cycleDuration;
      map.classList.toggle("is-cycle-visible", cycleTime < exitStart);
      map.classList.toggle("is-cycle-exiting", cycleTime >= exitStart && cycleTime < exitEnd);
      const phase = cycleTime < introDuration
        ? -1
        : cycleTime < transferEnd
          ? Math.floor((cycleTime - introDuration) / stepDuration)
          : cycleTime < exitStart
            ? sequence.length - 1
            : -1;
      setPhase(phase);
      window.requestAnimationFrame(animate);
    };

    window.requestAnimationFrame(animate);
  };

  setupOrderBuilder();
  setupPricingCards();
  setupSpecs();
  setupFaq();
  setupVideo();
  setupWorkflowTransfer();
  setupTeamSharing();
})();

(() => {
  const root = document.querySelector("[data-ut2-static]");
  if (!root) return;
  const orderSection = root.querySelector('[data-pencil-name="S4 Order Builder"]');
  const buildOrder = orderSection?.querySelector('[data-pencil-name="Build Order"]');
  if (!orderSection) return;

  const addItemsToCart = async (control, items) => {
    if (!items.length || control.getAttribute("aria-busy") === "true") return;

    control.setAttribute("aria-disabled", "true");
    control.setAttribute("aria-busy", "true");
    try {
      const response = await fetch(root.dataset.cartAddUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error("cart-add-failed");
      window.location.assign(root.dataset.cartUrl);
    } catch {
      control.setAttribute("aria-disabled", "false");
      control.removeAttribute("aria-busy");
    }
  };

  const bindActivation = (control, handler) => {
    if (!control) return;
    control.addEventListener("click", handler);
    control.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      handler(event);
    });
  };

  root.querySelectorAll("[data-pricing-quantity]").forEach((action) => {
    bindActivation(action, (event) => {
      event.stopPropagation();
      const quantity = Number.parseInt(action.dataset.pricingQuantity || "0", 10);
      const variantKey = action.dataset.pricingVariant || "standard";
      const variantId = Number.parseInt(root.dataset[`${variantKey}Variant`] || "0", 10);
      if (quantity < 1 || variantId < 1) return;
      addItemsToCart(action, [{ id: variantId, quantity }]);
    });
  });

  const closingAction = root.querySelector(
    '[data-pencil-name="S12 Closing CTA"] [data-pencil-name="CTA"]'
  );
  if (closingAction) {
    closingAction.setAttribute("role", "button");
    closingAction.tabIndex = 0;
    bindActivation(closingAction, (event) => {
      event.preventDefault();
      const targetTop = window.scrollY + orderSection.getBoundingClientRect().top;
      window.scrollTo({ top: targetTop, behavior: "smooth" });
    });
  }

  if (!buildOrder) return;

  buildOrder.addEventListener("click", async () => {
    if (buildOrder.getAttribute("aria-disabled") === "true") return;
    const standard = Number.parseInt(
      orderSection.querySelector('[data-pencil-name="Standard UT2"] [data-pencil-name="Count"]')?.value || "0",
      10
    );
    const bundle = Number.parseInt(
      orderSection.querySelector('[data-pencil-name="UT2 Bundle"] [data-pencil-name="Count"]')?.value || "0",
      10
    );
    const items = [];
    if (standard > 0 && root.dataset.standardVariant) {
      items.push({ id: Number(root.dataset.standardVariant), quantity: standard });
    }
    if (bundle > 0 && root.dataset.bundleVariant) {
      items.push({ id: Number(root.dataset.bundleVariant), quantity: bundle });
    }
    if (!items.length) return;
    addItemsToCart(buildOrder, items);
  });
})();

(() => {
  const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)");

  const activeElement = (selector) =>
    Array.from(document.querySelectorAll(selector)).find((element) => {
      const style = window.getComputedStyle(element);
      return style.display !== "none" && style.visibility !== "hidden" && element.offsetHeight > 0;
    });

  const globalHeaderOffset = () => {
    const announcementOffset = Number.parseFloat(
      window.getComputedStyle(document.documentElement).getPropertyValue("--announcement-bar-offset")
    ) || 0;
    const header = activeElement(".section-header-navigation, .section-header-mobile");
    if (!header || header.classList.contains("shopify-section-header-hidden")) {
      return announcementOffset;
    }

    const style = window.getComputedStyle(header);
    const rect = header.getBoundingClientRect();
    const anchored = style.position === "fixed" || style.position === "sticky";
    return anchored && rect.bottom > 0 ? Math.max(announcementOffset, rect.bottom) : announcementOffset;
  };

  const visibleHeaderStackHeight = () => {
    const announcement = activeElement("announcement-bar-component.announcement-bar");
    const desktop = activeElement(".section-header-navigation");
    const mobile = activeElement(".section-header-mobile");
    const mobileSiteNav = mobile ? activeElement(".section-header-nav-multi-site") : null;
    return (announcement?.offsetHeight || 0)
      + (desktop?.offsetHeight || mobile?.offsetHeight || 0)
      + (mobileSiteNav?.offsetHeight || 0);
  };

  const globalHeaderFlowHeight = () => {
    const header = activeElement(".section-header-navigation, .section-header-mobile");
    if (!header || header.classList.contains("scrolled-past-header")) return 0;
    return header.offsetHeight;
  };

  const setupCampaignNav = (root) => {
    if (root.dataset.ut2NavReady === "true") return;
    const nav = root.querySelector('[data-pencil-name="S2 Nav"]');
    if (!nav) return;

    root.dataset.ut2NavReady = "true";
    const controller = new AbortController();
    const { signal } = controller;
    let lastScrollY = window.scrollY;
    let scheduled = false;

    const links = Array.from(nav.querySelectorAll("a[data-ut2-anchor-target]"));
    links.forEach((link) => {
      const target = Array.from(root.querySelectorAll("[data-pencil-name]")).find(
        (element) => element.dataset.pencilName === link.dataset.ut2AnchorTarget
      );
      if (!target) return;

      target.id = link.hash.slice(1);
      target.setAttribute("data-ut2-anchor-section", "");
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const targetTop = window.scrollY + target.getBoundingClientRect().top;
        const movingDown = targetTop >= window.scrollY;
        const offset = movingDown
          ? nav.offsetHeight + globalHeaderFlowHeight() + 16
          : Math.max(nav.offsetHeight + 16, visibleHeaderStackHeight() + 16);
        window.scrollTo({
          top: Math.max(0, targetTop - offset),
          behavior: reducedMotion?.matches ? "auto" : "smooth"
        });
        window.history.pushState(null, "", link.hash);
      }, { signal });
    });

    const render = () => {
      if (!root.isConnected) {
        controller.abort();
        return;
      }

      const currentScrollY = window.scrollY;
      const atTop = currentScrollY <= 4;
      const scrollingDown = currentScrollY > lastScrollY + 2;
      const scrollingUp = currentScrollY < lastScrollY - 2;
      root.style.setProperty("--ut2-campaign-nav-top", `${Math.max(0, Math.round(globalHeaderOffset()))}px`);
      root.classList.toggle("nav-at-top", atTop);
      root.classList.toggle("nav-scrolled", currentScrollY > 4);

      if (atTop || scrollingDown) {
        root.classList.remove("nav-hidden");
        nav.removeAttribute("inert");
      } else if (scrollingUp) {
        root.classList.add("nav-hidden");
        nav.setAttribute("inert", "");
      }

      lastScrollY = currentScrollY;
      scheduled = false;
    };

    const scheduleRender = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(render);
    };

    window.addEventListener("scroll", scheduleRender, { passive: true, signal });
    window.addEventListener("resize", scheduleRender, { passive: true, signal });
    root.ut2NavCleanup = () => controller.abort();
    render();
  };

  document.querySelectorAll("[data-ut2-static]").forEach(setupCampaignNav);
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-ut2-static]").forEach(setupCampaignNav);
  });
  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-ut2-static]").forEach((root) => root.ut2NavCleanup?.());
  });
})();
